import { FC } from 'react';

import { useTranslations } from '@telialt/common-cms/src/useTranslations';
import HtmlContent from '@telialt/common-html-content/src';

import { HighlightedKeyword, SuggestionsNoResultsWrapper } from './SuggestionsNoResults.styles';

type Props = {
    keyword: string;
};

export const SuggestionsNoResults: FC<Props> = ({ keyword }) => {
    const { t } = useTranslations();

    return (
        <SuggestionsNoResultsWrapper>
            <HtmlContent content={t['search.component.suggestions_no_results.title']} />
            <HighlightedKeyword>{keyword}</HighlightedKeyword>
            <HtmlContent content={t['search.component.suggestions_no_results.content']} />
        </SuggestionsNoResultsWrapper>
    );
};
